import { GET_NOTIFICATIONS } from '../actionTypes';

const initialState = {
  notifications: []
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload
      };
    default: {
      return state;
    }
  }
};

export default notificationsReducer;
